export enum Knowledge {
  C = 1,
  N,
  X,
}
